<template>
  <!-- <renterCn v-if="!funcView.partner_renter_simple"></renterCn>
  <renterUs v-else></renterUs> -->
  <component :is="name"></component>
</template>

<script>
import renterCn from './children/renter.vue';
import renterUs from './children/renter_us.vue';

export default {
  name: 'renter',
  components: { renterCn, renterUs },
  data() {
    return {
      name: ''
    };
  },
  mounted() {
    // ocr识别 简版权限全在总部上管理
    this.getFuncView(null, () => {
      if (this.funcView.partner_renter_simple) {
        this.name = 'renterUs';
      } else {
        this.name = 'renterCn';
      }
    });
  }
};
</script>
